import {
    Form,
    Button
} from "react-bootstrap";
import { Link } from "react-router-dom";
import LoginScreen from "../../views/components/LoginScreen";
import { useRef, useState } from "react";
import { validateEmail } from "../../views/helpers";
import { sendPasswordResetEmail } from "../../data/dataApi";

const ResetPassword = () => {
    const [email, setEmail] = useState();
    const [emailError, setEmailError] = useState();
    const [emailSent, setEmailSent] = useState(false);
    const [emailResent, setEmailResent] = useState(false);

    const emailRef = useRef();

    const handleSendEmail = async () => {
        setEmailError("");
        const { value } = emailRef.current;
        setEmail(value);

        const response = await sendPasswordResetEmail(value);

        if(validateEmail(value, setEmailError) === "success") {
            if(response.error) {
                setEmailError(response.error.message);
            } else if(response.success) {
                setEmailSent(true);
            }
        }
    };

    const handleResendEmail = async () => {
        const response = await sendPasswordResetEmail(email);

        if(response.success) {
            setEmailResent(true);
        }
    };

    return(
        <LoginScreen>
            {
                !emailSent ?
                <>
                    <Link to="/" className="tertiary-btn tif-mb-sm-35">Back</Link>
                    <h1 className="tif-h2 tif-mb-15">Forgot password?</h1>
                    <p className="tif-mb-sm-70 tif-ls-25">Enter the email you used to create your account so we can send you a link for reseting your password.</p>

                    <Form className="primary-form">
                        <Form.Group className="form-group tif-mb-sm-30 tif-mb-20" controlId="formEmail">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control type="email" className={ emailError ? "has-error" : "" } placeholder="example@email.com" ref={ emailRef } />
                            { emailError && <p className="error-text">{ emailError }</p> }
                        </Form.Group>

                        <Button className="primary-btn tif-mb-15" onClick={ handleSendEmail }>Send</Button>
                        <Link to="/" className="secondary-btn">Back to Login</Link>
                    </Form>
                </>
                :
                <>
                    <h1 className="tif-h2 tif-mb-15">Check your email</h1>
                    <p className="tif-mb-sm-70 tif-mb-35 tif-ls-25">We have sent an email with password reset information to { email }</p>

                    <p className="tif-font-sm text-center tif-mb-md-15 tif-mb-10">Didn't receive the email? Check spam folder or</p>
                    <Button className="primary-btn tif-mb-md-15 tif-mb-10" disabled={ emailResent } onClick={ handleResendEmail }>{ emailResent ? "Sent!" : "Resend Email" }</Button>
                    <Link to="/" className="secondary-btn">Back to Login</Link>
                </>
            }
            
        </LoginScreen>
    );
};

export default ResetPassword;